import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { VipDiscountsEffects } from '@app/vip-discounts/store/vip-discounts.effects';
import { VipDiscountsFeature } from '@app/vip-discounts/store/vip-discounts.slice';
import { VipDiscountsModule } from '@app/vip-discounts/vip-discounts.module';
import { SharedModule } from '@shared/shared.module';

import { VipDiscountsReceivedTableComponent } from './pages/vip-discounts-received/vip-discounts-received-table/vip-discounts-received-table.component';
import { VipDiscountsReceivedComponent } from './pages/vip-discounts-received/vip-discounts-received.component';
import { VipDiscountsBuyingEffects } from './store/vip-discounts.effects';
import { VipDiscountsBuyingFeature } from './store/vip-discounts.slice';
import { VipDiscountsBuyingRoutingModule } from './vip-discounts-buying-routing.module';

@NgModule({
  declarations: [
    VipDiscountsReceivedComponent,
    VipDiscountsReceivedTableComponent,
  ],
  imports: [
    CommonModule,
    VipDiscountsBuyingRoutingModule,
    TranslateModule,
    StoreModule.forFeature(VipDiscountsFeature),
    StoreModule.forFeature(VipDiscountsBuyingFeature),
    EffectsModule.forFeature([VipDiscountsEffects, VipDiscountsBuyingEffects]),
    VipDiscountsModule,
    SharedModule,
  ],
})
export class VipDiscountsBuyingModule {}
